
import { MainAppController } from "@/app/ui/controllers/MainAppController";
import { ModalMessageEntities } from "@/domain/entities/MainApp";
import { prop, Vue } from "vue-class-component";
import { TemplateChat } from "@/domain/entities/PusatResolusiV2";
import { removeNewLineWhitespace } from "@/app/infrastructures/misc/Utils";

class Props {
  data = prop<TemplateChat>({
    default: new TemplateChat(),
    type: Object,
    required: true
  });
  index = prop<number>({
    default: 0,
    type: Number,
    required: true
  });
  maxLengthNewTemplate = prop<number>({
    default: 1000,
    type: Number,
    required: true
  });
}

export default class CardAddTemplate extends Vue.with(Props) {
  async mounted() {
    this.selectedTemplate = new TemplateChat();
    this.autoResize();
  }

  // state
  selectedTemplate = new TemplateChat();

  // template list
  autoResize() {
    const el = this.$refs?.templateEdit as HTMLTextAreaElement;

    if (!el) return;

    el.style.height = "auto";
    el.style.height = el.scrollHeight + "px";
  }
  toggleTooltipDelete(event: any) {
    const refs: any = this.$refs;
    refs?.tooltipDelete?.toggle(event);
  }

  toggleTooltipEdit(event: any) {
    const refs: any = this.$refs;
    refs?.tooltipEdit?.toggle(event);
  }
  get isSelected() {
    return this.selectedTemplate.position === this.data.position;
  }
  onDrag() {
    this.openSnackbar(
      this.$t('pusatResolusi.create.snackbarMessageTemplateList')
    );
  }
  onConfirmDelete(item: TemplateChat) {
    this.selectedTemplate = item;
    MainAppController.showMessageModal(
      new ModalMessageEntities({
        image: "badge-confirmation-general",
        title: this.$t('pusatResolusi.create.deleteTemplate'),
        message: this.$t('pusatResolusi.create.deleteTemplateMessage'),
        onClose: () => this.$emit("delete", this.data),
        onSubmit: () => {
          this.selectedTemplate = new TemplateChat();
          MainAppController.closeMessageModal();
        },
        textSuccess: this.$t('pusatResolusi.create.noBack'),
        textCancel: this.$t('pusatResolusi.create.yesDelete'),
        customWidth: "417px",
        customButton: "w-full",
        customParentButton: "w-full",
        customWrapperButton: "w-full px-6"
      })
    );
  }
  onEdit() {
    setTimeout(() => {
      this.selectedTemplate = Object.assign(new TemplateChat(), this.data);

      const el = this.$refs?.templateEdit as HTMLElement;
      if (el) {
        el.focus?.();
        el.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 55);
  }
  async onInputEdit(e: Event) {
    const target = e.target as HTMLTextAreaElement;
    this.data.templateMessage = target.value;

    await this.$nextTick();
    this.autoResize();
  }
  onCancelEdit() {
    setTimeout(() => {
      if (this.data.position === this.selectedTemplate.position) {
        this.data.templateMessage = this.selectedTemplate.templateMessage;
        this.selectedTemplate = new TemplateChat();

        this.$nextTick(() => {
          this.autoResize();
        });
      }
    }, 50);
  }
  handleEnter(event: KeyboardEvent) {
    if (event.shiftKey) {
      return;
    }
    // Prevent default dan submit
    event.preventDefault();
    this.onSubmitEdit();
  }
  onSubmitEdit() {
    if (!this.data.templateMessage.trim()) {
      this.onCancelEdit();
      return;
    }

    this.selectedTemplate = new TemplateChat();
    this.openSnackbar(
      this.$t('pusatResolusi.create.snackbarMessageEdit')
    );
  }

  // utils
  async openSnackbar(message: string) {
    MainAppController.setSnackbarRerender();
    await this.$nextTick();
    MainAppController.setSnackbarMessage(message);
    MainAppController.setSnackbarTimeout(3000);
    MainAppController.setSnackbar(true);
  }
  replaceNewLine(value: string) {
    const removedNewLineAddress = removeNewLineWhitespace(value, " ");
    this.data.templateMessage = removedNewLineAddress;
    return removedNewLineAddress;
  }
}
